import * as React  from 'react';
import { useState } from 'react';

const PER = 10;

const Companies = (props) => {
  const [marker, setMarker] = useState(PER);

  const loadList = () => {
    setMarker(marker + PER);
  }

  return (
    <>
      <h3>チケットデータ一覧</h3>
      <br/>
      <div className="table-responsive">
        <table id="notice_table" className="table table-bordered table-hover pointer">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-lg-1 col-md-1 col-sm-1 col-xs-1">id</th>
              <th scope="col" className="text-center col-lg-2 col-md-2 col-sm-2 col-xs-2">店舗コード</th>
              <th scope="col" className="text-center col-lg-3 col-md-6 col-sm-6 col-xs-6">事業所名</th>
              <th scope="col" className="text-center col-lg-1 col-md-6 col-sm-6 col-xs-6">総発行枚数</th>
              <th scope="col" className="text-center col-lg-1 col-md-6 col-sm-6 col-xs-6">残り枚数</th>
              <th scope="col" className="text-center col-lg-1 col-md-6 col-sm-6 col-xs-6">消費枚数</th>
              <th scope="col" className="text-center col-lg-1 col-md-6 col-sm-6 col-xs-6">期限切れ枚数</th>
              <th scope="col" className="text-center col-lg-2 col-md-6 col-sm-6 col-xs-6">購入金額合計(税抜)</th>
            </tr>
          </thead>
          <tbody>
            {JSON.parse(props.m_companies).map((company, i) => (
              <tr key={i}>
                <td className="text-center va_middle">{company.id}</td>
                <td className="text-center va_middle">{company.gcs_company_code}</td>
                <td className="text-center va_middle">{company.company_name}</td>
                <td className="text-center va_middle">{company.issue_ticket_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{company.enable_ticket_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{company.consumed_ticket_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{company.expired_ticket_count.toLocaleString()}枚</td>
                <td className="text-center va_middle">{company.total_purchased_price.toLocaleString()}円</td>
              </tr>
            )).slice(0, marker)}
          </tbody>
        </table>
        {
          props.companies_count > marker
            ? <div className="text-center"><button className="btn btn-default more-btn" onClick={loadList}>もっと表示 ▼</button></div>
            : ''
        }
      </div>
    </>
  )
}

export default Companies
